import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

/**
 * Renders a compact, envelope-style address block with graceful fallbacks.
 */
function OrderAddressBlock({ name, streetAddress, city, state, zipCode }) {
	// Build line 3 as "City, ST ZIP" when those values are available.
	const cityStateZip = [city, [state, zipCode].filter(Boolean).join(' ')]
		.filter(Boolean)
		.join(', ');
	const addressRowSx = { my: 0, lineHeight: 1.3 };

	const hasAddressData = !!(name || streetAddress || cityStateZip);

	return (
		<>
			{name && (
				<Typography
					variant="body"
					color="textPrimary"
					component="div"
					sx={addressRowSx}
				>
					{name}
				</Typography>
			)}
			{streetAddress && (
				<Typography
					variant="body"
					color="textPrimary"
					component="div"
					sx={addressRowSx}
				>
					{streetAddress}
				</Typography>
			)}
			{cityStateZip && (
				<Typography
					variant="body"
					color="textPrimary"
					component="div"
					sx={addressRowSx}
				>
					{cityStateZip}
				</Typography>
			)}
			{!hasAddressData && (
				<Typography
					variant="body"
					color="textPrimary"
					component="div"
					sx={addressRowSx}
				>
					-
				</Typography>
			)}
		</>
	);
}

OrderAddressBlock.propTypes = {
	name: PropTypes.string,
	streetAddress: PropTypes.string,
	city: PropTypes.string,
	state: PropTypes.string,
	zipCode: PropTypes.string,
};

export default OrderAddressBlock;
